
import LotterySignNewComponent from "../../../components/lottery_signs/New.vue";

export default {
  components: {
    LotterySignNewComponent
  }
};
